import { PreCheckoutInformation } from "common/types";
import { ItemTaxonomyId } from "lib/taxonomy/item-taxonomy-id";
import { IItemVersion, ItemDetails, ItemTypes } from "lib/types/items";

import { useCatalogicalGetSoftwareDetails } from "./useCatalogicalGetSoftwareDetails";
import { useGetHardwareDetails } from "./useGetHardwareDetails";
import { useLegacyGetSoftwareDetails } from "./useLegacyGetSoftwareDetails";

export interface useGetItemDetailsResult {
  type: ItemTypes;
  item: ItemDetails | undefined;
  isLoading: boolean;
  error: Error | undefined;
  defaultVersion: IItemVersion | undefined;
  versions: IItemVersion[];
  preCheckoutData?: PreCheckoutInformation;
  fetchPreCheckoutData?: (token: string) => void;
  getItem: (taxonomyId: ItemTaxonomyId) => void;
  updateVersionSelected: (version: any) => void;
}

export const useGetItemDetailsFactory = (
  taxonomyId: ItemTaxonomyId,
  toggleNewPdp: boolean = false
): (() => useGetItemDetailsResult) => {
  const domain: string = taxonomyId.dataDomain ?? "";
  switch (domain) {
    case "amznham":
      return useGetHardwareDetails;

    case "software":
    case "itsoftware":
      if (toggleNewPdp) {
        return useCatalogicalGetSoftwareDetails;
      }
      return useLegacyGetSoftwareDetails;
    default:
      return useLegacyGetSoftwareDetails;
  }
};
